module.exports = __webpack_public_path__ + "img/oldtype.ddf7925a.png";